import { useState } from 'react';
import { navLinks } from '../data';

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
              今日看瓜
            </span>
            <span className="mt-0.5 flex items-center gap-1.5 text-[11px] text-accent-600">
              <i className="ri-radio-2-line"></i>全网热门实时聚合
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#feed"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-broadcast-line"></i>进入热榜
          </a>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-3-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="flex items-center justify-between rounded-lg px-3 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              {link.label}
              <i className="ri-arrow-right-s-line text-secondary-500"></i>
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}